import React, { useState } from 'react';
import question from '../../../assets/question.svg';
import ComingSoon from '../../../components/common/ComingSoon';
import { useNavigate } from '@tanstack/react-router';
import { useSubscriptionDays } from '@/hooks/useSubscriptionDays';
import { useOrganization } from '@/hooks/useOrganization';

interface BottomMenuProps {
  isOpen: boolean;
}

export const BottomMenu: React.FC<BottomMenuProps> = ({ isOpen }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const navigate = useNavigate();
  const { daysRemaining } = useSubscriptionDays();
  const { organization } = useOrganization();

  const handleUpgrade = () => {
    navigate({ to: '/settings/plan' });
  };

  const handleHelpClick = () => {
    setShowComingSoon(true);
  };

  const isFreePlan = organization?.current_plan === 'free';

  return (
    <>
      {isOpen && (
        <div className="flex flex-col items-center justify-center w-full p-4 gap-[8px]">
          {isFreePlan && (
            <div className="flex items-center justify-between w-full bg-white py-[6px] px-[4px] rounded-[8px]">
              <div className="flex items-start gap-[4px]">
                <div className="text-sm font-normal text-[#12692B] bg-[#81F4A1] rounded-[4px] px-[6px]">
                  {daysRemaining}
                </div>
                <div className="text-sm text-gray-600">days left</div>
              </div>
              <div className='flex items-end'>
                <button 
                  onClick={handleUpgrade}
                  className="flex items-center justify-center w-[86px] h-[28px] bg-[#29DC5B] rounded-[8px] text-sm text-[#000000] font-normal "
                >
                  Upgrade
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      <ComingSoon 
        isOpen={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
    </>
  );
}; 